import Box from '@/components/UI/box/Box';
import Button from '@/components/UI/button/Button';
import styles from './RequestVisit.module.scss';
import Icon from '@/components/UI/icon/Icon';
import Typography from '@/components/UI/typography/Typography';
import { requestToVisitHouse } from '@/redux/store/actions/product';
import { useDispatch } from 'react-redux';
import { useRouter } from 'next/router';
import { useState } from 'react';
import { toast } from 'react-toastify';
const RequestVisit = ({
  open,
  onClose
}) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const [loading, setloading] = useState(false);
  const {
    id
  } = router.query;
  const requestVisit = () => {
    setloading(true);
    dispatch(requestToVisitHouse(Number(id), ({
      error,
      message
    }) => {
      setloading(false);
      if (!error) {
        toast.success('درخواست شما با موفقیت ثبت شد.');
        onClose();
      } else {
        toast.error(message);
      }
    }));
  };
  return <Box className={styles['request-drawer-container']} data-sentry-element="Box" data-sentry-component="RequestVisit" data-sentry-source-file="RequestVisit.tsx">
      <Box className={styles['request-icon']} data-sentry-element="Box" data-sentry-source-file="RequestVisit.tsx">
        <Icon name="stickynote" type="highEmphasis" data-sentry-element="Icon" data-sentry-source-file="RequestVisit.tsx" />
      </Box>
      <Typography component="p" variant="bodyL_Bold" color="neutral_800" data-sentry-element="Typography" data-sentry-source-file="RequestVisit.tsx">
        درخواست بازدید
      </Typography>
      <Typography component="p" color="neutral_main" variant="bodyL" data-sentry-element="Typography" data-sentry-source-file="RequestVisit.tsx">
        آیا از ارسال درخواست بازدید اطمینان دارید؟
      </Typography>

      <Box className={styles['request-button-wrapper']} data-sentry-element="Box" data-sentry-source-file="RequestVisit.tsx">
        <Button onClick={onClose} className={styles['request-button']} format="outlined" data-sentry-element="Button" data-sentry-source-file="RequestVisit.tsx">
          انصراف
        </Button>
        <Button disabled={loading} loading={loading} className={styles['request-button']} format="primary" onClick={requestVisit} data-sentry-element="Button" data-sentry-source-file="RequestVisit.tsx">
          ارسال درخواست
        </Button>
      </Box>
    </Box>;
};
export default RequestVisit;